import { api } from "./client";
import type { PagedResult } from "@/types/api";
import type {
  DraftEscrowRequest,
  EscrowBuyerEmailPreviewDto,
  EscrowTransactionDetailDto,
  EscrowTransactionDto,
  EscrowWebhookDiagnosticsDto,
  UpdateEscrowDraftRequest,
} from "@/types/escrow";

export interface EscrowListParams {
  page?: number;
  pageSize?: number;
  status?: string;
  includeArchived?: boolean;
  dealId?: string;
  q?: string;
}

export const escrowApi = {
  list: (params?: EscrowListParams) =>
    api.get<PagedResult<EscrowTransactionDto>>("/escrow-transactions", params),
  get: (id: string) =>
    api.get<EscrowTransactionDetailDto>(`/escrow-transactions/${id}`),
  buyerEmailPreview: (dealId: string) =>
    api.get<EscrowBuyerEmailPreviewDto>(`/escrow-transactions/deals/${dealId}/buyer-email`),
  draft: (body: DraftEscrowRequest) =>
    api.post<EscrowTransactionDetailDto>("/escrow-transactions/draft", body),
  updateDraft: (id: string, body: UpdateEscrowDraftRequest) =>
    api.patch<EscrowTransactionDetailDto>(`/escrow-transactions/${id}/draft`, body),
  approve: (id: string) =>
    api.post<EscrowTransactionDetailDto>(`/escrow-transactions/${id}/approve`),
  discard: (id: string) =>
    api.post<boolean>(`/escrow-transactions/${id}/discard`),
  archive: (id: string) =>
    api.post<EscrowTransactionDetailDto>(`/escrow-transactions/${id}/archive`),
  refresh: (id: string) =>
    api.post<EscrowTransactionDetailDto>(`/escrow-transactions/${id}/refresh`),
  diagnostics: () =>
    api.get<EscrowWebhookDiagnosticsDto>("/escrow-transactions/diagnostics"),
  reRegisterWebhook: () =>
    api.post<EscrowWebhookDiagnosticsDto>("/escrow-transactions/diagnostics/re-register-webhook"),
};
